<template>
  <router-view/>
</template>

<style lang="scss">
@use "sass:math";


// .design-bg {
//   background-repeat: no-repeat;
//   background-position: top center;
//   bottom: 0;
//   left: 50%;
//   margin: 0 auto;
//   opacity: 0.5;
//   position: absolute;
//   right: auto;
//   top: 0;
//   transform: translateX(-50%);
//   z-index: 10000;
// }

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
}

#app {
  background: $secondary_dark_blue;
  color: $white;
  font-family:"basic-sans";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  // min-height: calc(100vh);// minus header and footer
  margin: 0;
  padding: relative;
  width: 100%;
  
  
  * {
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family:"basic-sans";
  }

  p {
    font-family:"din-2014";
  }

  // foundation-like grid styles
  .full-width {
    max-width: 100%;
    width: 100%;
  }

  .row {
    display: flex;
    flex-flow: row wrap;
    flex-direction: row;
    margin-right: auto;
    margin-left: auto;
    max-width: 80rem;
    width: 100%;
  }

  .column, .columns {
    display: flex;
    flex: 1 1 0px;
    flex-direction: column;
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
    min-width: 0;

    @media print, screen and (min-width: 48em) {
      padding-right: 0.625rem;
      padding-left: 0.625rem;
    }
  }

  .no-mobile {
    display: none;

    @media print, screen and (min-width: 48em) {
      display: block;
    }
  }

  $large: 12;//grid size above 64em/1024px
  $medium: 12;//grid size above 48em/768px
  $small: 6;//grid size for smaller than tablet views
  $sizes: ("small", "medium", "large");

  @mixin push-pull-class($size, $number, $max) {
    $division: math.div($number, $max);
    $percent: percentage($division);

    .push-#{$size}-#{$number} {
      margin-left: $percent;
    }
    .pull-#{$size}-#{$number} {
      margin-right: $percent;
    }
  }

  @mixin generate-push-pull($size, $columns) {
    @for $column from 1 through $columns {
      @include push-pull-class($size, $column, $columns);
    }
  }
  
  @mixin column-class($size, $max, $number) {
    $division: math.div($number, $max);
    $percent: percentage($division);

    .#{$size}-#{$number} {
      flex: 0 0 $percent;
      max-width: $percent;
      width: $percent;
    }
  }
  
  @mixin generate_grid($size, $columns) {
    @for $column from 1 through $columns {
      @include column-class($size, $columns, $column);
    }
  }

  $alignments: ("normal", "stretch", "center", "start", "end", "flex-start", "flex-end", "self-start", "self-end", "baseline");
  $justify-alignments: ("center", "start", "end", "flex-start", "flex-end", "left", "right", "space-between", "space-around");
  $text-alignments: ("start", "end", "left", "right", "center", "justify", "justify-all", "match-parent");

  @mixin align-class($name, $property, $direction) {
    .#{$name}-#{$direction} {
      #{$property}: #{$direction};
    }
  }

  @mixin generate_alignments($name, $property, $set) {
    @each $alignment in $set {
      @include align-class($name, $property, $alignment);
    }
  }

  
  
  // small
  @include generate_grid("small", $small);
  @include generate-push-pull("small", $small);
  @include generate_alignments("align", "align-items", $alignments);
  @include generate_alignments("align-self", "align-self", $alignments);
  @include generate_alignments("justify", "justify-content", $justify-alignments);
  @include generate_alignments("justify-self", "justify-self", $alignments);
  @include generate_alignments("text-align", "text-align", $text-alignments);
  
  // medium
  @media print, screen and (min-width: 48em) {// 768px
    @include generate_grid("medium", $medium);
    @include generate-push-pull("medium", $medium);
  }
  // large
  @media print, screen and (min-width: 64em) {// 1024px
    @include generate_grid("large", $large);
    @include generate-push-pull("large", $large);
  }

  // animations
  @keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes fadeout {
    from { opacity: 1; }
    to { opacity: 0; }
  }

  @keyframes fadeindown {
    from {
      opacity: 0;
      transform: translateY(-50px);
     }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeinup {
    from {
      opacity: 0;
      transform: translateY(50px);
     }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeinleft {
    from {
      opacity: 0;
      transform: translateX(50px);
     }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeingrow {
    from {
      max-height: 0;
      opacity: 0;
     }
    to {
      max-height: 100%;
      opacity: 1;
    }
  }

  .animate {
    animation-duration: 1s;
    animation-fill-mode: both;
  }

  #homeView {
    #introView {
      h1 {
        br {
          display: none;

          @media print, screen and (min-width: 48em) {
            display: block;
          }
        }
      }
    }
  }
  #graphElement {
    .key-container {
      .key {
        p {
          // .box-text{
          //   display: block;
          //   margin: 0;
          //   padding: 0;
          //   position: relative;

          //   &:before {
          //     content: "";
          //     height: 20px;
          //     left: -14px;
          //     opacity: 1;
          //     position: absolute;
          //     top: 0;
          //     transition: opacity 0.3s;
          //     width: 20px;
          //   }
          // }
        }
      }
    }
  }
}
</style>
